import DateInput from '@/components/DateInput'

export default {
  name: 'ReturnAuthorisations',
  components: {
    DateInput
  },
  data () {
    return {
      returns: null,
      limitCount: 100,
      nextOffset: 0,
      loadingMore: false,
      filters: [
        { name: 'ID', key: 'id', value: '' },
        { name: 'Surname', key: 'family_name', value: '' },
        { name: 'First name', key: 'first_name', value: '' },
        { name: 'Email', key: 'email_address', value: '' },
        { name: 'Waiting', key: 'status', value: '1', type: 'checkbox', checked: true, default: true },
        { name: 'Authorised', key: 'status', value: '2', type: 'checkbox', checked: true, default: true },
        { name: 'Rectified', key: 'status', value: '3', type: 'checkbox', checked: false, default: false }
      ],
      shippingMethods: [
        'Australita Air Express',
        'Auspost',
        'Couriers Please',
        'Pick Up',
        'TNT',
        'NA'
      ],
      sizeClass: 'is-small',
      showEditModal: false,
      showCustomEmail: false,
      edit: {
        index: -1,
        return: null,
        key: null,
        title: '',
        type: null,
        value: null,
        loading: false
      },
      timestamp: -1,
      timer: null,
      updateInterval: 5000
    }
  },
  computed: {
    server () { return this.$store.getters.server }
  },
  created () {
    this.fetchReturns()
  },
  beforeDestroy () {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
      this.updateInterval = 0
    }
  },
  methods: {
    fetchReturns () {
      this.returns = null
      let data = {
        filters: this.getFilterData(),
        count: this.limitCount
      }
      this.$api('get_returns', data)
        .then(resp => {
          this.returns = resp.data
          this.timestamp = resp.timestamp
          this.nextOffset = resp.nextOffset
          this.fetchUpdatedReturns()
        })
        .catch(err => {
          this.returns = []
          this.showError(err)
        })
    },
    fetchMoreReturns () {
      if (this.loadingMore) {
        return
      }
      this.loadingMore = true
      let data = {
        filters: this.getFilterData(),
        count: this.limitCount,
        offset: this.nextOffset
      }
      this.$api('get_returns', data)
        .then(resp => {
          this.returns = this.returns.concat(resp.data)
          this.nextOffset = resp.nextOffset
          this.loadingMore = false
        })
        .catch(err => {
          this.loadingMore = false
          this.showError(err)
        })
    },
    fetchUpdatedReturns () {
      if (this.timer || !this.updateInterval) {
        return
      }
      this.timer = setTimeout(() => {
        clearTimeout(this.timer)
        this.timer = null
        let data = {
          timestamp: this.timestamp,
          filters: this.getFilterData()
        }
        this.$api('get_returns', data)
          .then(resp => {
            this.timestamp = resp.timestamp
            for (let updatedReturn of resp.data) {
              let id = Number(updatedReturn.id)
              let spliceIndex = -1
              let i = this.returns.findIndex((r, index) => {
                if (spliceIndex === -1 && id > Number(r.id)) {
                  spliceIndex = index
                }
                return r.id === updatedReturn.id
              })
              if (i >= 0) {
                if (updatedReturn.deleted === '1') {
                  this.deleteRow(i)
                } else {
                  this.updateRow(i, updatedReturn)
                }
              } else if (updatedReturn.deleted !== '1' && spliceIndex >= 0) {
                this.returns.splice(spliceIndex, 0, updatedReturn)
                this.flashRow(spliceIndex)
              }
            }
            this.fetchUpdatedReturns()
          })
          .catch(() => {
            this.showError()
            this.fetchUpdatedReturns()
          })
      }, this.updateInterval)
    },
    getFilterData () {
      let filterData = {}
      for (let filter of this.filters) {
        let value = null
        if (filter.type === 'checkbox') {
          if (filter.checked) {
            value = filter.value
          }
        } else {
          filter.value = filter.value.trim()
          if (filter.value.length) {
            value = filter.value
          }
        }

        if (value !== null) {
          if (filterData[filter.key] === undefined) {
            filterData[filter.key] = value
          } else {
            if (!Array.isArray(filterData[filter.key])) {
              filterData[filter.key] = [filterData[filter.key]]
            }
            filterData[filter.key].push(value)
          }
        }
      }
      return filterData
    },
    clearFilter () {
      for (let f of this.filters) {
        if (f.type === 'checkbox') {
          f.checked = f.default
        } else {
          f.value = ''
        }
      }
    },
    showError (errMsg) {
      this.$toast.open({
        duration: 5000,
        message: `ERROR: ${errMsg}`,
        type: 'is-danger'
      })
    },
    showEdit (key, index, type) {
      this.edit.index = index
      this.edit.return = JSON.parse(JSON.stringify(this.returns[index]))
      this.edit.key = key
      this.edit.title = key.replace(/_/g, ' ')
      this.edit.type = type
      this.edit.buttonTitle = 'Update'
      this.edit.loading = false
      this.showEditModal = true
      this.$nextTick(() => {
        if (this.$refs.focusInput) {
          if (typeof this.$refs.focusInput.focus === 'function') {
            this.$refs.focusInput.focus()
          } else if (typeof this.$refs.focusInput.$el.focus === 'function') {
            this.$refs.focusInput.$el.focus()
          }
        }
      })
    },
    closeEdit () {
      this.showEditModal = false
    },
    submitEdit () {
      this.edit.loading = true
      let value = this.edit.return[this.edit.key]
      let errMsg = ''
      if (this.edit.key === 'freight') {
        if (!this.edit.return.shipping_method.length) {
          errMsg += '<p>No shipping Method selected!</p>'
        }
        if (this.edit.return.date_sent === '0000-00-00') {
          errMsg += '<p>Date sent is invalid!</p>'
        }
        if (!errMsg) {
          value = {
            shipping_method: this.edit.return.shipping_method,
            tracking_num: this.edit.return.tracking_num,
            date_sent: this.edit.return.date_sent
          }
        }
      }
      if (errMsg.length) {
        this.$dialog.alert({
          title: 'Error',
          message: errMsg,
          type: 'is-danger'
        })
        this.edit.loading = false
      } else {
        this.setValue(this.edit.key, this.edit.index, this.edit.return.id, value)
          .then(this.closeEdit)
          .catch(this.closeEdit)
      }
    },
    downloadReport (index) {
      let r = this.returns[index]
      let req = {
        url: this.$store.getters.server,
        method: 'POST',
        responseType: 'blob',
        data: {
          req: 'download_report',
          id: r.id
        }
      }
      this.$http(req)
        .then(resp => {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${r.id}.pdf`)
          // document.body.appendChild(link)
          link.click()
        })
    },
    emailClicked (index) {
      this.edit.return = JSON.parse(JSON.stringify(this.returns[index]))
      if (!this.edit.return.email_address || !this.$utils.validateValue('email', this.edit.return.email_address)) {
        this.$dialog.alert({
          title: 'Error Sending email',
          message: `Email address for selected RA is invalid. "${this.edit.return.email_address}"`,
          type: 'is-danger',
          hasIcon: true,
          icon: 'times-circle',
          iconPack: 'fa'
        })
        return
      }
      this.edit.index = index
      this.edit.key = null
      this.edit.title = 'Send Email'
      this.edit.type = 'sendEmail'
      this.edit.value = ''
      this.edit.loading = false
      this.edit.buttonTitle = null
      this.showCustomEmail = false
      this.showEditModal = true
    },
    sendEmail (id, type) {
      this.$toast.open('SENDING EMAIL')
      this.showEditModal = false
      let req = { id, type }
      if (type === 'custom') {
        req.msg = this.edit.value
      }
      this.$api('sendEmail', req)
        .then(resp => {
          this.$toast.open({
            message: 'Email sent',
            type: 'is-success'
          })
          if (resp.data) {
            let index = this.returns.findIndex(item => item.id === id)
            if (index >= 0) {
              this.timestamp = resp.data.updated_timestamp
              this.$set(this.returns, index, resp.data)
            }
          }
        })
        .catch(err => {
          this.showError(err)
        })
    },
    showSendEmailDialog (raId, msg, emailType) {
      this.$dialog.confirm({
        title: `Send Email - RA #${raId}`,
        message: msg,
        cancelText: 'No',
        confirmText: 'Yes',
        type: 'is-primary',
        onConfirm: () => this.sendEmail(raId, emailType)
      })
    },
    deleteReturn (index) {
      let r = this.returns[index]
      if (!r) {
        this.$dialog.alert({
          title: 'Error Deleting Return Authorisation',
          message: `Could not find item at index`,
          type: 'is-danger',
          hasIcon: true,
          icon: 'times-circle',
          iconPack: 'fa'
        })
        return
      }
      this.$dialog.confirm({
        title: 'Deleting Return Authorisation',
        message: `Are you sure you want to <b>delete</b> return authorisation <b>${r.id}</b>? This action cannot be undone.`,
        confirmText: 'Delete',
        type: 'is-danger',
        onConfirm: () => {
          this.$api('delete_return', { id: r.id })
            .then(resp => {
              this.deleteRow(index)
            })
            .catch(err => {
              console.error(err)
            })
        }
      })
    },
    setAuthorised (index, authorised) {
      let ra = this.returns[index]
      let sendEmailMsg = null
      let emailType = null
      let msg = null
      if (authorised === 1) {
        let type = `${ra.email_1}` === '0' ? 'send' : '<em>resend</em>'
        sendEmailMsg = `Would you like to ${type} an email regarding <b>customer to send information</b>?`
        if (!ra.customer_to_send.length) {
          sendEmailMsg += `<br /><em>Please note that "Customer To Send" has no value</em>`
        }
        emailType = 'customerToSend'
      } else if (authorised === 2) {
        if (!ra.fault_report.trim().length) {
          msg = `You must enter a value for "Fault Report" before denying a customer to return the faulty product!`
        } else {
          let type = `${ra.email_2}` === '0' ? 'send' : '<em>resend</em>'
          sendEmailMsg = `Would you like to ${type} an email regarding why the return was <b>not authorised</b>?`
          emailType = 'notAuthorised'
        }
      }

      if (msg) {
        this.$dialog.alert({
          title: 'Cannot set authorisation',
          message: msg,
          type: 'is-warning'
        })
        return
      }

      this.setValue('authorise_return', index, ra.id, authorised)
        .then(() => {
          if (sendEmailMsg) {
            this.showSendEmailDialog(ra.id, sendEmailMsg, emailType)
          }
        })
    },
    setStatus (index, status) {
      let ra = this.returns[index]
      if (ra.status === status) {
        return
      }
      let msg = null
      let sendEmailMsg = null
      let emailType = null
      if (status === 2) {
        let type = `${ra.email_1}` === '0' ? 'send' : '<em>resend</em>'
        sendEmailMsg = `Would you like to ${type} an email regarding <b>customer to send information</b>?`
        if (!ra.customer_to_send.length) {
          sendEmailMsg += `<br /><em>Please note that "Customer To Send" has no value</em>`
        }
        emailType = 'customerToSend'
      } else if (status === 3) {
        if (`${ra.return}` === '0') {
          msg = `RA #${ra.id} needs to be authorised or rejected before setting its status to rectified`
        } else if (!ra.fault_report.length) {
          msg = 'You must enter a value for "Fault Report" before setting an RAs status to rectified'
        } else if (`${ra.return}` === '1' && !ra.shipping_method) {
          msg = `RA #${ra.id} needs freight details before setting its status to rectified`
          this.$dialog.confirm({
            title: 'No Freight Details',
            message: `RA #${ra.id} has no freight details. <p>Are you sure you want to close this RA?</p>`,
            cancelText: 'Cancel',
            confirmText: 'Close RA',
            type: 'is-warning',
            onConfirm: () => {
              this.setValue('status', index, ra.id, status)
            }
          })
          return
        } else {
          let type = `${ra.email_2}` === '0' ? 'send' : '<em><b>resend</b></em>'
          sendEmailMsg = `Would you like to ${type} an email regarding <b>shipping details?</b>`
          emailType = 'shippingDetails'
        }
      }

      if (msg) {
        this.$dialog.alert({
          title: 'Cannot set status',
          message: msg,
          type: 'is-warning'
        })
      } else {
        this.setValue('status', index, ra.id, status)
          .then(() => {
            if (sendEmailMsg) {
              this.showSendEmailDialog(ra.id, sendEmailMsg, emailType)
            }
          })
      }
    },
    setValue (key, index, id, value) {
      return new Promise((resolve, reject) => {
        this.$set(this.returns[index], 'loading', true)
        this.$api(`set_${key}`, { id, value })
          .then(resp => {
            this.timestamp = resp.data.updated_timestamp
            this.$set(this.returns, index, resp.data)
            resp.data.loading = false
            resolve()
          })
          .catch(err => {
            this.$set(this.returns[index], 'loading', false)
            this.showError(err)
            reject(err)
          })
      })
    },
    updateRow (i, updatedReturn) {
      this.$set(this.returns, i, updatedReturn)
      this.flashRow(i)
    },
    flashRow (i) {
      let ra = this.returns[i]
      if (!ra) return
      this.$set(this.returns[i], 'flash', true)
      setTimeout(() => {
        let i = this.returns.findIndex(r => r.id === ra.id)
        if (i >= 0) {
          this.$set(this.returns[i], 'flash', false)
        }
      }, 300)
    },
    deleteRow (i) {
      let ra = this.returns[i]
      if (!ra) return
      this.$set(this.returns[i], 'deleted', true)
      setTimeout(() => {
        let i = this.returns.findIndex(r => r.id === ra.id)
        if (i >= 0) {
          this.returns.splice(i, 1)
        }
      }, 600)
    }
  }
}
